import { buildSeverityGroups } from './validation-banner/build-severity-groups';
import { SeverityBanner } from './validation-banner/SeverityBanner';
import type { BannerIssue } from './validation-banner/types';

export type { BannerIssue } from './validation-banner/types';

export interface ValidationBannerProps {
  issues: BannerIssue[];
  onScrollTo?: (target: string) => void;
}

/**
 * Stacked severity banners (errors, then warnings, then info) summarising a list of
 * validation issues. Issues with a `groupId` are clustered into one row;
 * flat issues render with their `fieldLabel` as the heading.
 */
export function ValidationBanner({ issues, onScrollTo }: ValidationBannerProps) {
  if (issues.length === 0) return null;

  const groups = buildSeverityGroups(issues);
  if (groups.length === 0) return null;

  return (
    <div className='space-y-sm'>
      {groups.map(group => (
        <SeverityBanner key={group.severity} group={group} onScrollTo={onScrollTo} />
      ))}
    </div>
  );
}

ValidationBanner.displayName = 'ValidationBanner';
